export default __webpack_public_path__ + "static/media/2299.34ef2a96.png";